// extracted by mini-css-extract-plugin
module.exports = {"primaryGradient":"FlightClub_primaryGradient__n7v_r","strokedPrice":"FlightClub_strokedPrice__dp1Bo"};